<template>
  <div class="list-group-module">
    <div class="list-group" :style="{margin: tag ? '15px' : ''}">
<!--      <div class="tag" v-if="tag" :class="tagType">-->
<!--        <span :style="computedStyle(tag)">{{tag}}</span>-->
<!--      </div>-->
      <div class="tag-box" v-if="tag">
        <svg-icon :icon-class="`state-${tagType || 'info'}`"></svg-icon>
        <span :style="computedStyle(tag)">{{tag}}</span>
      </div>
      <slot name="top">
        <div class="top" :style="{ backgroundColor: topBgColor, flexDirection:flexDirection }">
          <div class="left" :style="{ backgroundColor: topLeftBgColor }">{{topLeftText}}</div>
          <div class="right">
            <slot name="topRight" v-if="topRightLabel || topRightValue">
              {{topRightLabel}}：{{topRightValue}}
            </slot>
          </div>
        </div>
      </slot>
      <div class="title">{{title}}</div>
      <div class="content">
        <slot name="content"></slot>
      </div>
      <van-divider></van-divider>

      <div class="foot">
        <div class="time">
          <slot name="footLeft">
            <svg-icon :icon-class="footLeftIcon" color="#999999"></svg-icon>
            {{footLeftLabel}}：{{footLeftValue}}
          </slot>
        </div>
        <div class="btn" :style="{width: footRightWidth}">
          <slot name="footRight"></slot>
        </div>
      </div>
      <div class="orderlist">
        <slot name="orderlist"></slot>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'listGroupModule',
  props: {
    data: Object,
    topLeftText: String,
    topRightLabel: String,
    topRightValue: String,
    topLeftBgColor: String,
    topBgColor: {
      type: String,
      default: '#F0FFEB'
    },
    flexDirection:{
      type:String,
      default:'row'
    },
    title: String,
    footLeftIcon: {
      type: String,
      default: '合同有效期'
    },
    footLeftLabel: String,
    footLeftValue: String,
    footRightWidth: {
      type: String,
      default: '100px'
    },
    tag: String,
    tagType: {
      type: String,
      default: 'info' // info warning success
    }
  },
  computed: {
    computedStyle(){
      return (val) => {
        if (val.length === 5) {
          return 'top:17px!important;right:-5px!important;'
        }else if (val.length === 4) {
          return 'top:17px!important;right:-1px!important;'
        }
      }
    }
  },
  data(){
    return{}
  },
}

</script>

<style scoped lang="less">
.list-group-module{
  position: relative;
  .list-group{
    background-color: #ffffff;
    padding: 10px;
    border-radius: 8px;
    position: relative;
    z-index: 2;

    .tag-box{
      position: absolute;
      width: 64px;
      height: 64px;
      z-index: 3;
      right: -8px;
      top: -8px;
      .svg-icon{
        width: 64px;
        height: 64px;
      }
      span{
        position: absolute;
        top: 14px;
        right: 4px;
        transform: rotate(45deg);
        font-size: 12px;
        color: #ffffff;
      }
    }



    .top{
      display: flex;
      align-items: center;
      line-height: 22px;
      color: #626561;
      .left{
        width: 84px;
        flex-shrink: 0;
        padding-left: 10px;
        color: #ffffff;
        clip-path: polygon(0% 0%, 100% 0%, 80% 100%, 0% 100%);
      }
      .right{
        width: 100%;
      }
    }

    .title{
      font-size: 16px;
      margin: 10px 0;
    }
    .van-divider {
      margin: 8px;
    }

    .content{
      color: #999999;
    }

    .foot{
      color: #999999;
      display: flex;
      align-items: center;
      line-height: 34px;
      >div{
        width: 100%;
        &:nth-child(1){
          display: flex;
          align-items: center;
        }
        &:nth-child(2){
          flex-shrink: 0;
        }
      }
    }



    .svg-icon {
      font-size: 16px !important;
    }
  }


  .info{
    background-color: #CCCCCC;
    border: 1px solid #CCCCCC;
  }
  .info-s{
    background-color: #999999;
  }

  .warning{
    background-color: #FFC107;
    border: 1px solid #FFC107;
  }
  .warning-s{
    background-color: #FFA000;
  }

  .success{
    background-color: #19C82A;
    border: 1px solid #19C82A;
  }
  .success-s{
    background-color: #079E4B;
  }
}
</style>
